import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {InfoDetail, InfoDetailVisit, InfoDetailLine, InfoDetailLoc} from "./style";

export default class Detail extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  renderDetailInfo() {
    let now = new Date();
    const {startTime} = this.props.itemInfo;
    const {accessNumber, bidCount} = this.props.realTimeData ? this.props.realTimeData : {}
    if (startTime > now) {
      return <InfoDetailVisit>{accessNumber}次围观</InfoDetailVisit>
    } else {
      return <InfoDetailVisit>{bidCount}次出价</InfoDetailVisit>
    }
  }

  render() {
    const {province} = this.props.itemInfo;
    return (
      <InfoDetail>
        {this.renderDetailInfo()}
        {province && province!='其他' &&
          <React.Fragment>  
            <InfoDetailLine></InfoDetailLine>
            <InfoDetailLoc>{province}</InfoDetailLoc>
           </React.Fragment>
        }
      </InfoDetail>
    )
  }
}
